import { render, staticRenderFns } from "./UserAddressSection.vue?vue&type=template&id=92ccdb5e&lang=pug"
import script from "./UserAddressSection.vue?vue&type=script&lang=js"
export * from "./UserAddressSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports